import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import { Component } from 'react';
import { defaultProps } from '../utils/defaultProps';
import shallowEqual from '../utils/shallowEqual';
import { getUidStr } from '../utils/uid';
import { open, close, destroy } from './events';

var DefaultValue = _objectSpread2(_objectSpread2({}, defaultProps), {}, {
  usePortal: true,
  visible: false,
  hideMask: false,
  esc: true
});

var Modal =
/*#__PURE__*/
function (_Component) {
  _inherits(Modal, _Component);

  var _super = _createSuper2(Modal);

  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _super.call(this, props);
    _this.id = void 0;
    _this.visible = void 0;
    _this.id = getUidStr();
    _this.visible = props.visible;
    _this.handleUpdate = _this.handleUpdate.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.visible && !this.props.usePortal) {
        open(this.getOption(), false);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      if (shallowEqual(this.props, nextProps)) return false;
      if (nextProps.visible) return true;
      close(_objectSpread2(_objectSpread2({}, this.props), {}, {
        id: this.id
      }), this.handleUpdate);
      return !shallowEqual(this.props, nextProps) && nextProps.visible;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.visible && !this.props.usePortal) {
        open(this.getOption(), false);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var usePortal = this.props.usePortal;
      close({
        id: this.id
      });
      destroy(this.id, !usePortal);
    }
  }, {
    key: "getOption",
    value: function getOption() {
      var _this$props = this.props,
          children = _this$props.children,
          usePortal = _this$props.usePortal,
          visible = _this$props.visible,
          props = _objectWithoutProperties(_this$props, ["children", "usePortal", "visible"]);

      return _objectSpread2(_objectSpread2({}, props), {}, {
        content: children,
        id: this.id,
        from: 'modal' // overwrite props from

      });
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate() {
      var destroyProps = this.props.destroy;
      if (destroyProps) this.forceUpdate();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          usePortal = _this$props2.usePortal,
          visible = _this$props2.visible;
      var option = this.getOption();
      if (visible && usePortal) return open(option, true);
      return null;
    }
  }]);

  return Modal;
}(Component);

Modal.defaultProps = DefaultValue;
Modal.displayName = void 0;
Modal.info = void 0;
Modal.warn = void 0;
Modal.error = void 0;
Modal.confirm = void 0;
Modal.show = void 0;
Modal.success = void 0;
Modal.closeAll = void 0;
Modal.Submit = void 0;
Modal.displayName = 'ShineoutModal';
export default Modal;